export function getApiBaseUrl() {
  let base = String(import.meta.env.VITE_API_BASE_URL || "").trim();
  if (!base || base === "undefined") {
    const isLocal =
      typeof window !== "undefined" &&
      /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
    base = isLocal
      ? "http://localhost:5000"
      : "https://fexlogistics-2.onrender.com";
  }
  if (!/\/api\/?$/.test(base)) {
    base = base.replace(/\/?$/, "") + "/api";
  }
  return base;
}
